export default __webpack_public_path__ + "static/clean-valley-water-5e15f669cae1c91b9cefe7154b8a3d9b.png";